import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetChatListStats = {
  getChatListStats: { data: null, loading: false, error: null },
};

export const getChatListStats = createAsyncThunk('user/getChatListStats', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/chat/chats/categories`, {
      params: { ...data, subtype: undefined },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetChatListStats = {
  [getChatListStats.pending]: (state) => {
    // state.getChatListStats.data = null;
    state.getChatListStats.loading = true;
    state.getChatListStats.error = null;
  },
  [getChatListStats.fulfilled]: (state, action) => {
    state.getChatListStats.loading = false;
    state.getChatListStats.data = action.payload;
    state.getChatListStats.error = null;
  },
  [getChatListStats.rejected]: (state, action) => {
    state.getChatListStats.loading = false;
    state.getChatListStats.error = action.payload;
  },
};
